import './index.css';
import 'dayjs/locale/ko';
import '../sentry.mjs';
import 'photoswipe/dist/photoswipe.css';
// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Dayjs from "dayjs";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactDOMExperimental from "rescript-relay/src/ReactDOMExperimental.mjs";
import * as App$CardocFrontendPartners from "./App.mjs";
import CustomParseFormat from "dayjs/plugin/customParseFormat";
import * as Providers$CardocFrontendPartners from "./providers/Providers.mjs";
import * as ChannelWebSdkLoader from "@channel.io/channel-web-sdk-loader";

Dayjs.locale("ko");

Dayjs.extend(CustomParseFormat);

ChannelWebSdkLoader.loadScript();

ReactDOMExperimental.renderConcurrentRootAtElementWithId(JsxRuntime.jsx(Providers$CardocFrontendPartners.make, {
          children: JsxRuntime.jsx(App$CardocFrontendPartners.make, {})
        }), "root");

export {
  
}
/*  Not a pure module */
